if (!customElements.get('wishit-circle-carousel')) {
  class WishitCircleCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.carouselReady === 'true') return;

      this.track = this.querySelector('[data-wishit-track]');
      this.previousButton = this.querySelector('[data-wishit-previous]');
      this.nextButton = this.querySelector('[data-wishit-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.dataset.carouselReady = 'true';
      this.handlePrevious = () => this.move(-1);
      this.handleNext = () => this.move(1);
      this.handleScroll = () => this.updateButtons();
      this.handleKeydown = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      };

      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.track.addEventListener('keydown', this.handleKeydown);

      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.track);
      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track.removeEventListener('scroll', this.handleScroll);
      this.track.removeEventListener('keydown', this.handleKeydown);
      this.resizeObserver?.disconnect();
      delete this.dataset.carouselReady;
    }

    move(direction) {
      const firstItem = this.track.querySelector('.wishit-equal-item');
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const itemStep = firstItem ? firstItem.getBoundingClientRect().width + gap : this.track.clientWidth;
      const visibleItems = Math.max(1, Math.floor(this.track.clientWidth / itemStep));
      const itemsPerMove = Math.max(1, Math.floor(visibleItems / 2));
      const amount = Math.max(itemStep, itemStep * itemsPerMove);

      this.track.scrollBy({
        left: amount * direction,
        behavior: 'smooth',
      });
    }

    updateButtons() {
      const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const currentScroll = Math.abs(this.track.scrollLeft);

      this.previousButton.disabled = currentScroll <= 1;
      this.nextButton.disabled = currentScroll >= maximumScroll - 1;
    }
  }

  customElements.define('wishit-circle-carousel', WishitCircleCarousel);
}
